<template>
  <div class="calendar-day"
     @click="emitDate"
    :class="calendar_day_classes">
    <div class="calendar-day_date">{{ day }}</div>
    <div
      class="calendar-day_date-inner"
      :class="`date-${date_str}`">
      <div
        v-if="get_background_text"
        :title="get_background_text"
        class="calendar-day_bg-text">
        <div>{{get_background_text}}</div>
      </div>
    </div>
  </div>
</template>

<script>

import {getDateFormatShortDateStr} from "../../../mixins/dateMixin";

const SATURDAY = 6
const SUNDAY = 0

export default {
  name: "CalendarDay",
  props: {
    day: {
      type: Number,
      required: true
    },
    month_index: {
      type: Number,
      required: true
    },
    year: {
      type: Number,
      required: true
    },
    current_date: {
      type: String,
      required: true
    },
    selected_dates: {
      type: Array,
      default: () => []
    },
    background_texts_by_date: {
      type: Object,
      default: null
    },
    disabled_dates: {
      type: Array,
      default: () => []
    },
    selectable_weekend: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    month() {
      return this.month_index+1
    },
    date_str() {
      return `${this.year}-${this.month}-${this.day}`
    },
    is_today() {
      return this.date_str === this.current_date
    },
    current_date_class() {
      return new Date(`${this.year}-${this.month_index+1}-${this.day}`)
    },
    is_saturday() {
      return this.current_date_class.getDay() === SATURDAY
    },
    is_sunday() {
      return this.current_date_class.getDay() === SUNDAY
    },
    is_weekday() {
      return this.is_saturday || this.is_sunday
    },
    is_disabled_date() {
      return this.disabled_dates.includes(this.date_str)
    },
    calendar_day_classes() {
      return {
        current_day: this.is_today,
        weekend_selectable: this.selectable_weekend,
        is_weekday: this.is_weekday,
        disabled_date: this.is_disabled_date,
        selected_date: this.selected_dates.includes(this.date_str),
      }
    },
    get_background_text() {
      if (!this.background_texts_by_date) return
      return this.background_texts_by_date[this.date_str] || ''
    }
  },
  methods: {
    emitDate() {
      if ((this.is_weekday && !this.selectable_weekend) || this.is_disabled_date) return
      let date_str = getDateFormatShortDateStr(this.current_date_class, '-')
      return this.$emit('selectedDay', date_str)
    }
  }
}
</script>
